import { ValidationErrors } from '@angular/forms';

/**
 * The single Dutch validation dictionary. A pure function rather than a template of
 * @if branches, so it is unit-testable without a TestBed and cannot drift per screen.
 * Order matters: the first matching key wins, and required beats everything.
 */
export function fieldErrorMessage(
  errors: ValidationErrors | null | undefined,
): string | null {
  if (!errors) {
    return null;
  }
  if (errors['required']) {
    return 'Veld is verplicht.';
  }
  if (errors['email']) {
    return 'Gelieve een geldig e-mailadres op te geven.';
  }
  if (errors['pattern']) {
    return 'Wachtwoord moet 8 tekens lang zijn, met 1 hoofdletter en 1 nummer.';
  }
  if (errors['minlength']) {
    return `Moet minstens ${errors['minlength'].requiredLength} tekens lang zijn.`;
  }
  if (errors['min']) {
    return 'Waarde te laag.';
  }
  if (errors['max']) {
    return 'Waarde te hoog.';
  }
  if (errors['noMatch']) {
    return 'Wachtwoorden komen niet overeen.';
  }
  if (errors['emailTaken']) {
    return 'E-mailadres bestaat al.';
  }
  if (errors['chipIdDoesNotExist']) {
    return 'Gelieve eerst je chipnummer te laten activeren.';
  }
  return null;
}
